import { SectionDivider } from '@domain-group/suit-theme'

import useCampaignQuotes from '@hooks/useCampaignQuotes'

import type { CampaignModel } from '@models/types'

import CampaignQuoteListItem from '../CampaignQuoteListItem'

interface ApprovedQuotesProps {
  campaign: CampaignModel,
}

const ApprovedQuotes = (props: ApprovedQuotesProps) => {
  const { campaign } = props

  const campaignQuotesPayload = useCampaignQuotes({
    filters: {
      campaign_id: campaign.id,
      status: 'approved',
    },
    performHttpRequests: false,
  })

  const { filteredCampaignQuotes, hasFilteredCampaignQuotes } = campaignQuotesPayload

  if (!hasFilteredCampaignQuotes) return null

  return (
    <>
      <SectionDivider boxProps={{ marginBottom: 'large' }}>Approved</SectionDivider>

      {filteredCampaignQuotes.map(campaignQuote => (
        <CampaignQuoteListItem
          key={campaignQuote.id}
          // @ts-expect-error TS2322
          campaignQuote={campaignQuote}
        />
      ))}
    </>
  )
}

export default ApprovedQuotes
